export const common = {
  // Navigation
  'nav.home': 'Accueil',
  'nav.services': 'Soins',
  'nav.about': "L'Univers",
  'nav.testimonials': 'Témoignages',
  'nav.gallery': 'Galerie',
  'nav.contact': 'Contact',
  'nav.book': 'Prendre rendez-vous',

  // Hero
  'hero.title': 'Révélez votre éclat intérieur',
  'hero.subtitle': 'Un refuge de bien-être et de beauté au coeur d\'Angré Château, où chaque soin est une parenthèse enchantée',
  'hero.cta': 'Prendre rendez-vous',
  'hero.discover': 'Découvrir nos soins',

  // Stats
  'stats.clients': 'Clientes Satisfaites',
  'stats.experience': 'Années d\'Expertise',
  'stats.treatments': 'Soins Proposés',
  'stats.rating': 'Note Moyenne',

  // Process
  'process.title': 'Votre Parcours Bien-Être',
  'process.subtitle': 'Quatre étapes simples pour un moment rien que pour vous',
  'process.step1.title': 'Choisir',
  'process.step1.desc': 'Parcourez notre catalogue de soins et sélectionnez celui qui vous fait envie. Chaque prestation est détaillée avec prix et durée.',
  'process.step2.title': 'Réserver',
  'process.step2.desc': 'Appelez-nous au +225 07 57 00 69 69 ou remplissez le formulaire en ligne. Nous vous confirmons sous 2 heures.',
  'process.step3.title': 'Venir',
  'process.step3.desc': 'Rendez-vous à Angré Château, Carrefour Cabri. Un parking est à votre disposition pour un accès facile.',
  'process.step4.title': 'Profiter',
  'process.step4.desc': 'Laissez-vous chouchouter par nos expertes. Repartez apaisée, belle et pleine d\'énergie.',

  // Engagements
  'engagements.title': 'Nos engagements',
  'engagements.subtitle': 'Une expérience sensorielle unique, conçue pour sublimer votre beauté naturelle',
  'engagements.clean.title': 'Produits Clean',
  'engagements.clean.desc': 'Des formulations naturelles et respectueuses de votre peau, sans parabènes ni sulfates',
  'engagements.expertise.title': 'Expertise Certifiée',
  'engagements.expertise.desc': 'Des praticiennes formées aux meilleures techniques internationales de soin',
  'engagements.custom.title': 'Soins Sur-Mesure',
  'engagements.custom.desc': 'Un diagnostic personnalisé pour adapter chaque protocole à votre profil unique',
  'engagements.wellness.title': 'Bien-être Holistique',
  'engagements.wellness.desc': 'Une approche globale alliant corps, esprit et beauté pour un éclat durable',

  // Services
  'services.title': 'Nos soins phares',
  'services.subtitle': 'Des prestations d\'exception pour sublimer votre beauté naturelle',
  'services.from': 'À partir de',
  'services.duration': 'min',
  'services.discover': 'Découvrir',
  'services.all': 'Voir tous nos soins',

  // Testimonials
  'testimonials.title': 'Ce que nos clientes disent',
  'testimonials.subtitle': 'Des témoignages authentiques, des résultats visibles et un sentiment partagé : la confiance retrouvée',

  // CTA Banner
  'cta.title': 'Offre Découverte',
  'cta.subtitle': 'Votre première prestation à -20%',
  'cta.desc': 'Offre valable pour toute nouvelle cliente sur les soins du visage, du corps ou le massage relaxant. Un moment de pure détente vous attend dans notre spa.',
  'cta.button': 'Réserver mon soin',

  // Gallery
  'gallery.title': 'L\'ambiance KD\'S',
  'gallery.subtitle': 'Un espace pensé comme un refuge, où chaque détail invite à la détente',

  // Footer
  'footer.about': 'À propos',
  'footer.about.desc': 'KD\'S BEAUTY, votre spa de référence à Angré Château. Un lieu où beauté, bien-être et expertise se rencontrent pour vous offrir une expérience inoubliable.',
  'footer.quickLinks': 'Liens rapides',
  'footer.hours': 'Horaires d\'ouverture',
  'footer.contact': 'Contact',
  'footer.newsletter': 'Newsletter',
  'footer.newsletter.desc': 'Recevez nos offres exclusives et conseils beauté chaque mois',
  'footer.newsletter.placeholder': 'Votre adresse email',
  'footer.newsletter.button': 'S\'inscrire',
  'footer.followUs': 'Suivez-nous',
  'footer.legal': 'Mentions légales',
  'footer.privacy': 'Politique de confidentialité',
  'footer.copyright': '© {{year}} KD\'S BEAUTY. Tous droits réservés.',

  // Contact info
  'contact.address': 'Angré Château, Carrefour Cabri',
  'contact.city': 'Abidjan, Côte d\'Ivoire',
  'contact.phone1': '+225 07 57 00 69 69',
  'contact.phone2': '+225 05 06 00 55 50',
  'contact.email': 'contact@kdsbeauty.ci',

  // Form
  'form.name': 'Nom complet',
  'form.email': 'Email',
  'form.phone': 'Téléphone',
  'form.subject': 'Motif',
  'form.message': 'Votre message',
  'form.send': 'Envoyer le message',
  'form.success': 'Votre message a été envoyé avec succès !',
  'form.error': 'Une erreur est survenue. Veuillez réessayer.',
  'form.required': 'Ce champ est requis',

  // Not found
  'notFound.title': 'Page introuvable',
  'notFound.desc': 'La page que vous recherchez n\'existe pas ou a été déplacée.',
  'notFound.back': 'Retour à l\'accueil',
};

export default common;